import { useState } from 'react';
import { addComparingGamesPlus } from '../services';
import { ComposedDateMode } from '@/pages/intelligence/components/ComposedDatePicker/enums';
import type { ICommonActionRes, IDateType, IDateValue } from '@/pages/intelligence/types/common';
import type { IPCConsoleGame } from '@/pages/intelligence/types/pcConsoleCompare';

export default function useAddGames(option: {
  addComparingGames?: (games: IPCConsoleGame[]) => Promise<ICommonActionRes>;
  updateCompareTableData: (params?: { games?: IPCConsoleGame[] }) => Promise<void>;
  updateCompareTrendsData: (params?: {
    games?: IPCConsoleGame[];
    mode?: ComposedDateMode;
    dateType?: IDateType;
    dateValue?: IDateValue;
    callback?: (res: any) => void;
  }) => Promise<void>;
}) {
  const { addComparingGames, updateCompareTableData, updateCompareTrendsData } = option || {};

  const add = typeof addComparingGames === 'function' ? addComparingGames : addComparingGamesPlus;

  const [visible, setVisible] = useState(false);

  const handleAddClick = () => {
    setVisible(true);
  };
  const handleAddConfirm = (gamesIds: string[], games: IPCConsoleGame[]) => {
    add(games);
    updateCompareTableData({ games });
    updateCompareTrendsData({ games });
    setVisible(false);
  };
  const handleAddClose = () => {
    setVisible(false);
  };

  return {
    visible,
    onAddClick: handleAddClick,
    onAddConfirm: handleAddConfirm,
    onAddClose: handleAddClose,
  };
}
